import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { OrderedMap } from 'immutable';
import identity from 'transmute/identity';
import createViewFilters from 'SalesContentIndexUI/data/utils/createViewFilters';
import getDefaultViewFilter from 'SalesContentIndexUI/data/utils/getDefaultViewFilter';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import configureStore from 'SalesContentIndexUI/data/redux/configureStore';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import SearchReducer from 'SalesContentIndexUI/data/redux/reducers/SearchReducer';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import ViewFiltersReducer from 'SalesContentIndexUI/data/redux/reducers/ViewFiltersReducer';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import IndexUIActionsMiddleware from 'SalesContentIndexUI/data/redux/middleware/IndexUIActionsMiddleware';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import SalesContentIndexUIReduxContext from 'SalesContentIndexUI/data/redux/SalesContentIndexUIReduxContext';
import DefaultSort from 'SalesContentIndexUI/data/lib/DefaultSort';
import TableRowLimit from 'SalesContentIndexUI/constants/TableRowLimit';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import SearchActions from 'SalesContentIndexUI/data/actions/SearchActions';
import FolderActions from 'SalesContentIndexUI/data/actions/FolderActions';
import IndexUIActions from 'SalesContentIndexUI/data/actions/IndexUIActions';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import ModalDecorator from 'SalesContentIndexUI/decorators/ModalDecorator';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import QueryParamDecorator from 'SalesContentIndexUI/decorators/QueryParamDecorator';
import createIndexTableContainer from './createIndexTableContainer';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../u... Remove this comment to see the full error message
import { assertPropsDefined } from '../utils/PropValidationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export default (({
  looseItemContentType,
  folderContentType,
  additionalViewFilters = OrderedMap(),
  allContentFilterList,
  getUserId,
  getTeamIds,
  tableColumns,
  searchFetch,
  TableRow,
  FolderRow,
  EmptyState = () => /*#__PURE__*/_jsx("div", {}),
  isModal = false,
  searchOptions = {
    currentSort: DefaultSort,
    currentViewFilterName: null,
    onSetSort: identity,
    onSetViewFilter: identity,
    onSetFolder: identity,
    onSearch: identity,
    searchLimit: TableRowLimit.INDEX
  },
  useOwnerViewFilters = false,
  onClickNew,
  showTemplateCreateButton
}) => {
  assertPropsDefined({
    looseItemContentType,
    folderContentType,
    getUserId,
    getTeamIds,
    tableColumns,
    searchFetch,
    TableRow,
    FolderRow
  });
  const viewFilters = createViewFilters({
    looseItemContentType,
    folderContentType,
    getUserId,
    getTeamIds,
    additionalViewFilters,
    useOwnerViewFilters
  });
  const defaultViewFilter = getDefaultViewFilter({
    viewFilters,
    currentViewFilterName: searchOptions.currentViewFilterName,
    isModal,
    looseItemContentType,
    folderContentType
  });
  SearchActions.init({
    searchFetch,
    looseItemContentType,
    folderContentType,
    defaultViewFilter,
    searchOptions
  });
  const store = configureStore({
    search: SearchReducer({
      defaultViewFilter,
      // TODO: Eventually remove this fallback to defaultViewFilter
      allContentFilterList: allContentFilterList || defaultViewFilter.getFilters(),
      looseItemContentType,
      folderContentType,
      isModal,
      options: searchOptions
    }),
    viewFilters: ViewFiltersReducer({
      viewFilters
    })
  }, IndexUIActionsMiddleware);
  FolderActions.init(searchFetch);
  IndexUIActions.init(store.dispatch);
  const IndexTableContainer = createIndexTableContainer({
    folderContentType,
    tableColumns,
    TableRow,
    FolderRow,
    EmptyState,
    isModal,
    looseItemContentType,
    useOwnerViewFilters,
    onClickNew,
    showTemplateCreateButton
  });
  const DecoratedIndexTableContainer = isModal ? ModalDecorator(IndexTableContainer) : QueryParamDecorator(IndexTableContainer);
  const ConnectedIndexTableContainer = props => /*#__PURE__*/_jsx(Provider, {
    store: store,
    context: SalesContentIndexUIReduxContext,
    children: /*#__PURE__*/_jsx(DecoratedIndexTableContainer, Object.assign({}, props))
  });
  ConnectedIndexTableContainer.propTypes = {
    children: PropTypes.any
  };
  return ConnectedIndexTableContainer;
});